import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
const ProtectedRoute=({children})=>{
    let {currentUser}=useAuth();
   
    if(!currentUser){
return(<Navigate to='/SignUp'/>);
    }
    return children;
};

export default ProtectedRoute;